export const buildField = function(fieldTemplate, valuesToAddOrOverride={}) {
    /**
     * Build field object for forms. Use it to build all fields for the following reasons:
     *      1. Ensure that if a field is used on different forms on the same page, if they are supposed to have
     *         different properties, they don't reference the same object.
     *      2. Use to override properties of an default field object in the `fields` directory.
     *
     * Arguments:
     *  fieldTemplate[object] --> field template for which to add field Props into. One of the prebuilt templates in `fields` directory
     *
     *
     * Keyword Arguments:
     *  valuesToAddOrOverride[object] --> object with fieldProps and values for which to add or override
     *
     * Returns:
     *  field[object] --> fieldObject entirely built
     */

    const fieldProperties = [
        'type',
        'label',
        'model',
        'id',
        'placeholder',
        'inputName',
        'inputType',
        'featured',
        'visible',
        'values',
        'disabled',
        'required',
        'readonly',
        'multi',
        'default',
        'hint',
        'help',
        'validator',
        'validateDebounceTime',
        'onChanged',
        'onPlaceChanged',
        'styleClasses',
        'buttons',
        'attributes'
    ];

    let field = {};
    for (let fieldProp in fieldTemplate) {
        if (fieldProperties.includes(fieldProp)) {
            field[fieldProp] = fieldTemplate[fieldProp];
        }
    }

    for (let fieldProp in valuesToAddOrOverride) {
        if (fieldProperties.includes(fieldProp)) {
            field[fieldProp] = valuesToAddOrOverride[fieldProp];
        }
    }
    return field;
}
